import { AppSettings } from "src/config/app-setting";
import { OutputDto } from "./OutputDto";
import { InputDto } from "./InputDto";

export class DeviceDto {
  nomeFlotta: string;
  nomeMezzo: string;
  nomeImpianto: string;
  codPerif: string;
  targa: string;
  marca: string;
  modello: string;
  stato: string;
  statoDateTime: Date;
  inputs: InputDto[];
  outputs: OutputDto[];

  private _lockInput?: InputDto;
  private _lockOutput?: OutputDto;
  private _doorInput?: InputDto;

  constructor(data: Partial<DeviceDto> = {}) {
    this.nomeFlotta = data?.nomeFlotta ?? '';
    this.nomeMezzo = data?.nomeMezzo ?? '';
    this.nomeImpianto = data?.nomeImpianto ?? '';
    this.codPerif = data?.codPerif ?? '';
    this.targa = data?.targa ?? '';
    this.marca = data?.marca ?? '';
    this.modello = data?.modello ?? '';
    this.stato = data?.stato ?? '';
    this.statoDateTime = data?.statoDateTime ?? new Date();
    this.inputs = (data.inputs ?? []).map(i => new InputDto(i));
    this.outputs = (data.outputs ?? []).map(i => new OutputDto(i));
  }

  get lockInput(): InputDto | undefined {
    if (this._lockInput === undefined) {
      this._lockInput = this.extractLockInput();
    }
    return this._lockInput;
  }

  get lockOutput(): OutputDto | undefined {
    if (this._lockOutput === undefined) {
      this._lockOutput = this.extractLockOutput();
    }
    return this._lockOutput;
  }

  get doorInput(): InputDto | undefined {
    if (this._doorInput === undefined) {
      this._doorInput = this.extractDoorInput();
    }
    return this._doorInput;
  }

  private extractLockInput() : InputDto | undefined {
    const lockInputs = this.inputs.filter(input => input.isLock);

    let isValid = false;

    if (lockInputs.length == 0)
      console.error(`In device '${this.nomeImpianto}' (codPerif ${this.codPerif}) none of the inputs (${this.inputs.map(o => o.fieldName).join(", ")}) is a 'lock' input.`);
    else if (lockInputs.length > 1)
      console.error(`In device '${this.nomeImpianto}' (codPerif ${this.codPerif}) there are ${lockInputs.length} inputs (${lockInputs.map(o => o.fieldName).join(", ")}) that are 'lock' inputs.`);
    else
      isValid = true;

    return isValid ? lockInputs[0] : undefined;
  }

  private extractLockOutput() : OutputDto | undefined {
    const lockOutputs = this.outputs.filter(output => output.isLock);

    let isValid = false;

    if (lockOutputs.length == 0)
      console.error(`In device '${this.nomeImpianto}' (codPerif ${this.codPerif}) none of the outputs (${this.outputs.map(o => o.fieldName).join(", ")}) is a 'lock' output.`);
    else if (lockOutputs.length > 1)
      console.error(`In device '${this.nomeImpianto}' (codPerif ${this.codPerif}) there are ${lockOutputs.length} outputs (${lockOutputs.map(o => o.fieldName).join(", ")}) that are 'lock' outputs.`);
    else
      isValid = true;

    return isValid ? lockOutputs[0] : undefined;
  }

  private extractDoorInput() : InputDto | undefined {
    const doorInputs = this.inputs.filter(input => input.isDoor);

    return doorInputs.length === 1 ? doorInputs[0] : undefined;
  }
}